import { LoginProvider } from '../../shared/models/loginProvider';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { AppProfile } from '../../shared/app-profile/app-profile';
// import { Token } from 'src/app/shared/models/token';
// import { Utils } from './session-expire.service';
import { AppStateService } from './app-state.service';
import { CookieService } from 'ngx-cookie-service'; // Ensure this is the correct library for CookieService
import { User } from '../../shared/models/user';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private static readonly ACCESS_TOKEN = 'accessToken';
    private static readonly TOKEN = 'token';
    private static readonly REFRESH_TOKEN = 'refreshToken';
    private static readonly ID_TOKEN = 'idToken';
    private static readonly USER_ID = 'user_id';
    private static readonly USER_NAME = 'user_name';
    public static readonly LOGOUT_PATH = '/ampm/logout';
    private static readonly USER_TOP_ORG_ID = 'userTopOrgId';

    private loggedIn: BehaviorSubject<boolean>;
    private loggingOut = false;

    get isLoggedIn() {
        return this.loggedIn.asObservable();
    }
    get accessToken() {
        return this.cookieService.get(AuthService.ACCESS_TOKEN);
    }
    get token() {
        return this.cookieService.get(AuthService.TOKEN);
    }
    // get refreshToken() {
    //     return this.cookieService.get(AuthService.REFRESH_TOKEN);
    // }
    // get idToken() {
    //     return this.cookieService.get(AuthService.ID_TOKEN);
    // }
    // get userId() {
    //     return this.cookieService.get(AuthService.USER_ID);
    // }
    get userName() {
        return this.cookieService.get(AuthService.USER_NAME);
    }
    get userTopOrgId() {
        return this.cookieService.get(AuthService.USER_TOP_ORG_ID);
    }
    get userPermissions(): any[] {
        const permissions = this.cookieService.get('userPermissions');
        try {
            return permissions ? JSON.parse(permissions) : [];
        } catch {
            return [];
        }
    }

    hasPermission(...permissions: string[]): boolean {
        return permissions.some(permission => this.userPermissions.includes(permission));
    }

    constructor(
        private router: Router,
        private httpClient: HttpClient,
        private appProfile: AppProfile,
        // private errorService: ErrorService,
        private appState: AppStateService,
        private cookieService: CookieService
    ) {
        this.loggedIn = new BehaviorSubject<boolean>(this.authenticate());
    }

    public getLoginProvider(event): Observable<LoginProvider> {
      // for local use
      const url = '/ampmperfapi/logins';
      // Request headers
      const headers = new HttpHeaders({
        'api-version': '2.0.0'
      });
      // Request body (matches your --data-raw)
      const body = event;

      // Make the POST request
      return this.httpClient.post<LoginProvider>(`${this.appProfile.epUs}/auth-ms/logins`, body, { headers }).pipe(
        map((response: any) => {
          const loginProvider: LoginProvider = {
            url: response.url,
            username: response.username,
            password: response.password,
            applicationId: response.applicationId,
            status: response.errorCode,
            message: response.errorMessage,
            token: response.token,
            userPermissions: response.userPermissions || [],
          };
          if (response) {
            // Store the access token in local storage or a cookie
            this.storeToken(response);
          }
          return loginProvider;
        })
      );
    }

    public handleRefreshToken() {
        const body = {
            // refresh_token: this.refreshToken
        };
        const options = { params: new HttpParams().set('applicationName', 'Insights') };

        return this.httpClient.post(`${this.appProfile.apiURL}/ampm/refreshToken`, body, options).pipe(
            // tap((user: User) => {
            //     // refresh successful if the response has access token
            //     if (user && user.access_token) {
            //         // store user details and jwt token in the local storage to keep the user logged in between page refreshes
            //         this.storeToken(user);
            //     } else {
            //         this.logout();
            //     }
            // })
        );
    }

    public logout() {
        if (!this.loggingOut) {
            this.loggingOut = true;
            this.removeActiveInstance();
        }
    }

    private handleLoginError(message: string) {
        // this.appState.triggerForcedLogout(message);
        this.logout();
    }

    private iamLogout() {
        const body = {
            // access_token: this.accessToken,
            // id_token_hint: this.idToken,
            // refresh_token: this.refreshToken
        };
        const httpOptions = {
            params: new HttpParams().set('applicationName', 'platformPrototypeUI'),
        };
        return this.httpClient.post(`${this.appProfile.apiURL}${AuthService.LOGOUT_PATH}`, body, httpOptions);
    }

    private authenticate(): boolean {
        return this.cookieService.check(AuthService.TOKEN || AuthService.ACCESS_TOKEN);
    }

    public storeToken(user: User) {
        this.setCookie(AuthService.USER_ID, user.token.userId);
        this.setCookie(AuthService.USER_NAME, user.user_name);
        this.setCookie(AuthService.ACCESS_TOKEN, user.iamToken);
        this.setCookie(AuthService.TOKEN, user.token && typeof user.token === 'string' ? user.token : JSON.stringify(user.token));
        this.setCookie(AuthService.ID_TOKEN, user.token.uniqueId);
        if (user.refresh_token) {
            this.setCookie(AuthService.REFRESH_TOKEN, user.refresh_token);
        }
        // Store userPermissions if present (loosen type to any for compatibility)
        if (user.userPermissions) {
            this.setCookie('userPermissions', JSON.stringify(user.userPermissions));
        }
        if (user.userTopOrgId) {
            this.setCookie(AuthService.USER_TOP_ORG_ID, user.userTopOrgId);
        }
        this.loggedIn.next(this.authenticate());
    }

    private setCookie(key: string, value: string | undefined) {
        if (key && value) {
            this.cookieService.set(key, value, 365, '/', null, null, null);
        }
    }

    private clearStorage() {
        this.cookieService.deleteAll('/');
        // Utils.clearSessionObjects('TIMER');
    }

    public removeActiveInstance() {
        this.clearStorage();
        this.loggedIn.next(this.authenticate());
        this.router.navigate(['/login']);
    }

    getCommonHeaders(token: string, version?: string): HttpHeaders {
        return new HttpHeaders({
            'X-tenant-Id': '2faca8f1-c381-4122-a634-471e1075dd8d',
            'org': '2faca8f1-c381-4122-a634-471e1075dd8d',
            'Content-Type': 'application/json',
            'api-version': version,
            'auth-token': token
        });
    }

}
